import { liveQuerySubscribeLock, LIVE_QUERY_SUBSCRIBE_LOCK_KEY } from 'util/asyncLocks';
import {
  isSpecialist,
  isSpecialistLite,
  getSelectedInboxTab,
  getWhiteList,
  extractNominatedTickets,
  extractNonHistoricalTicketIdFromState,
  getPartnersAllowlist,
} from 'extractFromState';
import { getEscalatedTabFilterParameters } from 'selectors/filters';
import { updateTicketInQueue } from 'actions/ticketActions';
import { addTicketToQueue, removeTicketFromQueue, selectTicket } from 'actions';
import {
  CONVERSATION_ENTER_SUBSCRIPTION,
  CONVERSATION_UPDATE_SUBSCRIPTION,
  CONVERSATION_LEAVE_SUBSCRIPTION,
} from './conversationSubscriptions.gql';
import subscribeToLiveQuery from '../subscribeToLiveQuery';
import { isEqual } from 'lodash';
import { getEscalatedTicketsBaseQuery } from '../../api/tickets/queries';
import isEmpty from 'lodash/isEmpty';

let escalatedQueueSubscriptions = [];
let escalatedQueueFilterParams = null;

const startEscalatedLiveQuery = (store) => {
  const state = store.getState();
  if (!isSpecialist(state)) {
    return;
  }

  const selectedInboxTab = getSelectedInboxTab(state);
  const filterParams = getEscalatedTabFilterParameters(state);
  const whiteList = getWhiteList(state);
  const partnersAllowlist = getPartnersAllowlist(state);

  if (
    !escalatedQueueSubscriptions.length ||
    (escalatedQueueSubscriptions.length && !isEqual(filterParams, escalatedQueueFilterParams))
  ) {
    if (escalatedQueueSubscriptions.length) {
      escalatedQueueSubscriptions.forEach((es) => es.unsubscribe());
      escalatedQueueSubscriptions = [];
      escalatedQueueFilterParams = null;
    }
    // TODO: parse implementation lets you to unsubscribe and re-subscribe if the filter params doesn't match
    // need to figureout the same here

    liveQuerySubscribeLock.acquire(LIVE_QUERY_SUBSCRIBE_LOCK_KEY, async (lockDoneFunction) => {
      const filter = getEscalatedTicketsBaseQuery({ ...filterParams, whiteList, partnersAllowlist });

      const handleOnEnter = async (conversationObj) => {
        // do not update redux store if specialist lite and ticket not in whitelist
        const userIsSpecialistLite = isSpecialistLite(store.getState());
        const whitelist = getWhiteList(store.getState());
        if (
          userIsSpecialistLite &&
          whitelist &&
          conversationObj.simplrAccountId &&
          !whitelist.includes(conversationObj.simplrAccountId)
        ) {
          // Ignore conversation that is not within whitelist
          return;
        }

        const isConversationExcludedByPartnersAllowlist =
          !isEmpty(partnersAllowlist) &&
          conversationObj.simplrAccountId &&
          !partnersAllowlist.includes(conversationObj.simplrAccountId);
        if (isConversationExcludedByPartnersAllowlist) {
          return;
        }

        const nominatedTickets = extractNominatedTickets(store.getState());
        if (!nominatedTickets[conversationObj.objectId]) {
          store.dispatch(
            addTicketToQueue({
              conversation: conversationObj,
              queueName: 'nominated',
            })
          );
        }
      };

      const handleOnLeave = (conversationObj) => {
        const nominatedTickets = extractNominatedTickets(store.getState());

        if (!nominatedTickets[conversationObj.objectId]) {
          return;
        }

        const previouslySelectedTicketId = extractNonHistoricalTicketIdFromState(store.getState(), 'nominated');
        store.dispatch(removeTicketFromQueue(conversationObj.objectId, 'nominated', isSpecialist(store.getState())));

        if (previouslySelectedTicketId === conversationObj.objectId) {
          store.dispatch(selectTicket('', 'nominated'));

          const newSelectedTicketId = extractNonHistoricalTicketIdFromState(store.getState(), 'nominated');
          // eslint-disable-next-line
          const selectedInboxTab = getSelectedInboxTab(store.getState());
          if (newSelectedTicketId && selectedInboxTab === 'nominated') {
            store.dispatch(selectTicket(newSelectedTicketId, selectedInboxTab));
          }
        }
      };

      const handleOnUpdate = (conversationObj) => {
        if (selectedInboxTab === 'nominated') {
          store.dispatch(updateTicketInQueue(conversationObj, selectedInboxTab, isSpecialist(store.getState())));
        }
      };

      escalatedQueueFilterParams = filterParams;

      const updateSubscription = subscribeToLiveQuery(
        CONVERSATION_UPDATE_SUBSCRIPTION,
        { filter },
        'onUpdateConversation',
        handleOnUpdate
      );

      const enterSubscription = subscribeToLiveQuery(
        CONVERSATION_ENTER_SUBSCRIPTION,
        { filter },
        'onEnterConversation',
        handleOnEnter
      );

      const leaveSubscription = subscribeToLiveQuery(
        CONVERSATION_LEAVE_SUBSCRIPTION,
        { filter },
        'onLeaveConversation',
        handleOnLeave
      );

      escalatedQueueFilterParams = filterParams;
      escalatedQueueSubscriptions.push(updateSubscription, enterSubscription, leaveSubscription);
      lockDoneFunction();
    });
  }
};

export { startEscalatedLiveQuery };
